module.exports = __webpack_public_path__ + "files/743b42a3ace84553402144b6b186eb99.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Caligraphic-Bold.ttf
// module id = 1131
// module chunks = 60